<template>
	<div class="personalform">
		<el-form ref="form" :rules="rules" :model="form" label-width="400" label-position="top">
			<el-form-item label="实名类型：" prop="holder_type" v-if="holder_type.length>0">
				<ul class="type between">
					<li v-for="v,k in holder_type" :key="v.value" class="align-c cur" :class="form.holder_type==v.value?'on':''" @click="ontype(v.value)">
						<img src="@/static/z-icon-checked.png" class="checked">
						<img src="@/static/z-icon-gr.png" class="icon" />
						<div class="k">
							<div class="t">{{v.label}}</div>
							<div class="t2" v-if="v.remark">{{v.remark}}</div>
						</div>
					</li>
				</ul>
			</el-form-item>

			<!-- 个人 -->
			<template v-if="form.holder_type==1">
				<el-form-item label="姓名：" prop="holder_name">
					<el-input v-model="form.holder_name" placeholder="请输入您的真实姓名"></el-input>
				</el-form-item>
				<el-form-item label="上传身份证：" prop="isidcardurl">
					<el-input v-model="form.isidcardurl" style="display: none;"></el-input>
					<div class="between">
						<div class="id-upload-card" @click="triggerUpload('front')">
							<div class="loading vcenter" v-if="frontUrl_loading">
								<div class="align-c"><i class="el-icon-loading"></i>上传中...</div>
							</div>
							<input ref="frontInput" type="file" accept="image/jpeg,image/png" style="display: none"
								@change="handleFileChange($event,'front')" />
							<div v-if="form.frontUrl" class="preview">
								<img :src="form.frontUrl" alt="身份证" />
								<div class="mask">
									<i class="el-icon-delete" @click.stop="clearImage('front')"></i>
								</div>
							</div>
							<div v-else class="placeholder">
								<img src="@/static/z-idcardbg1.png" class="bg">
								<div class="ts vcenter">上传身份证正面</div>
							</div>
						</div>

						<div class="id-upload-card" @click="triggerUpload('back')">
							<div class="loading vcenter" v-if="backUrl_loading">
								<div class="align-c"><i class="el-icon-loading"></i>上传中...</div>
							</div>
							<input ref="backInput" type="file" accept="image/jpeg,image/png" style="display: none"
								@change="handleFileChange($event,'back')" />
							<div v-if="form.backUrl" class="preview">
								<img :src="form.backUrl" alt="身份证" />
								<div class="mask">
									<i class="el-icon-delete" @click.stop="clearImage('back')"></i>
								</div>
							</div>
							<div v-else class="placeholder">
								<img src="@/static/z-idcardbg2.png" class="bg">
								<div class="ts vcenter">上传身份证反面</div>
							</div>

						</div>
					</div>
					<div class="idcard-ts">
						<div class="t">身份证上传要求</div>
						<div class="t2">请确保身份证边框完整，字迹清晰可见，亮度均匀，文字正向显示。</div>
					</div>


				</el-form-item>
				<el-form-item label="身份证号：" prop="id_card">
					<el-input v-model="form.id_card" maxlength="18" placeholder="请输入您的身份证号"></el-input>
				</el-form-item>
				<el-form-item label="地址：" prop="address">
					<el-input v-model="form.address" placeholder="请输入您的收件地址"></el-input>
				</el-form-item>
			</template>


			<!-- 机构 -->
			<template v-if="form.holder_type==2">
				<el-form-item label="机构名称：" prop="company">
					<el-input v-model="form.company" placeholder="请输入机构名称"></el-input>
				</el-form-item>
				<el-form-item label="统一机构代码：" prop="org_code">
					<el-input v-model="form.org_code" placeholder="请输入统一机构代码"></el-input>
				</el-form-item>
				<el-form-item label="上传营业执照：" prop="yyzzimg">
					<div class="yyzzupload">
						<el-upload
							ref="yyzzUpload"
							:class="{ 'upload-limit-reached': yyzzimglist.length >= 1 }"
						  :limit="1"
						  :action="upload_action"
						  :headers="header"
						  list-type="picture-card"
						  :file-list="yyzzimglist"
						  :on-success="handleUploadSuccess"
						  :on-preview="handlePictureCardPreview"
						  :on-remove="handleRemove"
						  :on-exceed="handleExceed"
						  :on-change="handleChange"
						  :before-upload="beforeUpload"
						>
						  <!-- 关键：只有未达到 limit 时才显示 + 按钮 -->
						  <i v-if="yyzzimglist.length < 1" class="el-icon-plus"></i>
						</el-upload>
						<el-dialog append-to-body :visible.sync="yyzzimgdialogVisible">
							<img width="100%" :src="dialogImageUrl" alt="">
						</el-dialog>
					</div>

				</el-form-item>
				<el-form-item label="法人/经营者：" prop="manager">
					<el-input v-model="form.manager" placeholder="请输入法人/经营者"></el-input>
				</el-form-item>
				<el-form-item label="单位地址：" prop="company_address">
					<el-input v-model="form.company_address" placeholder="单位地址"></el-input>
				</el-form-item>
				<el-form-item label="证件有效期：" prop="zjdate">
					<div class="rdate">
						<el-date-picker value-format="yyyy-MM-dd" v-model="form.zjdate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</div>
				</el-form-item>
			</template>



			<el-form-item label="持有品类：">
				<div class="elcheckbox">
					<el-checkbox-group v-model="holding_cate_checked">
						<el-checkbox :key="v.value" :label="v.value" v-for="v,k in holding_cate">{{v.name}}</el-checkbox>
					</el-checkbox-group>
				</div>
			</el-form-item>
			<el-form-item label="备注说明：">
				<el-input type="textarea" placeholder="请输入您的爱好、收藏方向" v-model="form.note" rows="6" maxlength="30"
					show-word-limit>
				</el-input>
			</el-form-item>
		</el-form>
		<div class="btn-box vcenter" v-if="status!=2">
			<el-button type="primary" class="green curadm" :loading="loading" @click="onSubmit">确认并提交</el-button>
		</div>
	</div>
</template>

<script>
	import util from "@/common/util.js";
	import ty from "@/utils/ty/ty"
	import { Message } from 'element-ui'
	import { mapMutations } from "vuex";
	export default {
		name: 'formpage',
		props: {
			// 外部参数示例
			// data: {
			//     type: Array,
			//     default: () => []
			// },
		},
		data() {
			return {
				// 内部参数
				loading:false,
				dialogImageUrl: '',
				yyzzimgdialogVisible:false,
				yyzzimglist:[],
				holder_type:[],
				holding_cate:[],
				holding_cate_checked:[],
				header:"",
				upload_action:process.env.VUE_APP_API_ROOT+"web/admin/file/images",
				frontUrl_loading:false,
				backUrl_loading:false,
				status:null,
				form: {
					holder_type: 1,
					holder_name: "",
					frontUrl: '', // 正面图片 URL
					backUrl: '', // 反面图片 URL
					isidcardurl: null,
					id_card: "",
					address: "",
					

					// 机构
					company:"",
					org_code: "",
					license_img: "",
					manager: "",
					company_address: "",
					zjdate: [],

					// 公共
					holding_cate:"",
					note: "",

				},
				checkList: [],
				rules: {
					holder_type: [{
						required: true,
						message: '请选择实名类型',
						trigger: 'blur'
					}, ],
					holder_name: [{
						required: true,
						message: '请输入您的真实姓名',
						trigger: 'blur'
					}, ],
					isidcardurl: [{
							required: true,
							message: '请上传身份证',
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if (value == 1) {
									callback(new Error('请上传身份证反面'));
								} else if (value == 2) {
									callback(new Error('请上传身份证正面'));
								} else {
									callback();
								}
							},
							trigger: 'change'
						}
					],
					id_card: [{
						required: true,
						message: '请输入您的身份证号',
						trigger: 'blur'
					},{
							validator: (rule, value, callback) => {
								if (!util.chksfz(value)) {
									callback(new Error('请输入正确的身份证号'));
								} else {
									callback();
								}
							},
							trigger: 'change'
						} ],

					// 机构
					company: [{
						required: true,
						message: '请输入您的真实姓名',
						trigger: 'blur'
					}, ],
					org_code: [{
						required: true,
						message: '请输入统一机构代码',
						trigger: 'blur'
					}, ],
					company_address: [{
						required: true,
						message: '请输入单位地址',
						trigger: 'blur'
					}, ],

				}
			}
		},
		watch: {
			"form.frontUrl"() {
				this.isidcardurl()
			},
			"form.backUrl"() {
				this.isidcardurl()
			},
		},
		methods: {
			...mapMutations(["setToken", "setUserInfo", "logout"]),
			init(){
				this.header = {
					'Authorization': 'Bearer ' + this.$store.state.token
				}
				ty.ajax("web/holder/holder/detail",{}).then((d)=>{
					this.holder_type = d.data.holder_type
					this.holding_cate = d.data.holding_cate
					var detail = d.data.data
					this.status = detail.status
					if (detail.holder_type){
						this.form.holder_type = detail.holder_type || 1
						this.form.holder_name = detail.holder_name
						this.form.frontUrl = detail.id_card_front
						this.form.backUrl = detail.id_card_reverse
						this.form.id_card_front = this.form.frontUrl
						this.form.id_card_reverse = this.form.backUrl
						
						this.form.id_card = detail.id_card
						this.form.address = detail.address
						
						this.form.note = detail.note
						
						this.form.company = detail.company
						this.form.org_code = detail.org_code
						this.form.manager = detail.manager
						this.form.company_address = detail.company_address
						if (detail.startdate && detail.enddate){
							this.form.zjdate = [detail.startdate,detail.enddate]
						}
						
						if (detail.license_img){
							this.yyzzimglist = [
								{
									status:"success",
									url:detail.license_img,
									response:{
										url:detail.license_img,
									}
								}
							]
						}
						
						
						var holding_cate_str = detail.holding_cate
						var holding_cate = []
						if (holding_cate_str){
							holding_cate = holding_cate_str.split(",").map(Number);
							this.holding_cate_checked = holding_cate
						}
					}

				})
			},
			onSubmit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						var form = this.form
						form.id_card_front = form.frontUrl
						form.id_card_reverse = form.backUrl
						form.holding_cate = this.holding_cate_checked.join(",")
						if (form.zjdate.length>0){
							form.startdate = form.zjdate[0]
							form.enddate = form.zjdate[1]
						}
						if (this.yyzzimglist.length>0){
							form.license_img = this.yyzzimglist[0].response.url
						}
						util.vconfirm("确定要提交吗,提交后将无法修改",()=>{
							this.loading = true
							ty.ajax("web/holder/holder/update",form).then((d)=>{
								this.setUserInfo(d.data)
								util.vmsg('提交成功');
								this.init()
								this.$emit("personal")
								this.loading = false
							}).catch((err)=>{
								this.loading = false
							})
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},

			ontype(n) {
				this.form.holder_type = n
				this.clearValidation()
			},

			//身份证上传===============
			isidcardurl() {
				if (!this.form.frontUrl && !this.form.backUrl) {
					this.form.isidcardurl = null
				} else if (this.form.frontUrl && !this.form.backUrl) {
					this.form.isidcardurl = 1
				} else if (!this.form.frontUrl && this.form.backUrl) {
					this.form.isidcardurl = 2
				} else {
					this.form.isidcardurl = 3
				}
			},
			triggerUpload(n) {
				this.$refs[n + 'Input'].click();
			},
			handleFileChange(e, n) {
				const file = e.target.files[0];
				if (!file) return;

				// 校验
				if (!['image/jpeg', 'image/png'].includes(file.type)) {
					this.$message.error('仅支持 JPG/PNG 格式');
					return;
				}
				if (file.size > 10 * 1024 * 1024) {
					this.$message.error('文件不能超过 10MB');
					return;
				}

				

				// 上传（示例）
				const formData = new FormData();
				formData.append('file', file);
				this[n + 'Url_loading']=true
				util.upload("web/admin/file/images",formData,(d)=>{
					// 预览
					this.form[n + 'Url'] = d.url;
					this[n + 'Url_loading']=false
				},(d)=>{
					util.valert("上传失败")
					this[n + 'Url_loading']=false
				})
			},
			clearImage(n) {
				this.form[n + 'Url'] = '';
				this.$refs[n + 'Input'].value = ''; // 清空 input
				this.isidcardurl()
			},
			
			//清除表单验证
			clearValidation() {
			    this.$refs.form.clearValidate()
			},

			//营业执照上传
			handleUploadSuccess(response, file, fileList){
				// 假设后端返回格式为 { code: 200, data: { url: 'https://xxx.jpg' } }
				console.log("handleUploadSuccess",response)
			  if (response.code) {
				this.$message.error(response.message);
				this.handleUploadError(null, file, fileList);
			  } else {
				this.yyzzimglist = fileList;
				this.$message.success('上传成功');
			  }
			},
			
			// 上传失败（网络错误、HTTP 非 2xx 等）
			handleUploadError(err, file) {
			  //this.$message.error('上传失败，请重试');
		
			  // ✅ 关键：从 el-upload 内部 fileList 中移除当前失败的文件
			  const uploadRef = this.$refs.yyzzUpload;
			  if (uploadRef && uploadRef.uploadFiles) {
				// 过滤掉当前失败的文件（通过 uid）
				uploadRef.uploadFiles = uploadRef.uploadFiles.filter(f => f.uid !== file.uid);
			  }
		
			  // 同时确保 yyzzimglist 也不包含它（虽然通常不会加，但保险）
			  this.yyzzimglist = this.yyzzimglist.filter(f => f.uid !== file.uid);
			},
			
			handleRemove(file, fileList) {
				console.log("handleRemove",file)
				this.yyzzimglist = fileList;
			},
			handlePictureCardPreview(file) {
				console.log("handlePictureCardPreview",file)
				this.dialogImageUrl = file.url;
				this.yyzzimgdialogVisible = true;
			},
			handleChange(file, fileList) {
				console.log("handleChange",file)
				// if (file.response.code){
				// 	 Message.error(file.response.message)
				// 	//fileList.slice(0, 1)
				// }
			    this.yyzzimglist = fileList; // 或 fileList.slice(0, 2)
			  },
			beforeUpload(file){
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
				  const isLt10M = file.size / 1024 / 1024 < 10;
			
				  if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
				  }
				  if (!isLt10M) {
					this.$message.error('上传头像图片大小不能超过 10MB!');
				  }
				  return isJPG && isLt10M;
			},
			handleExceed() {
				this.$message.warning('最多只能上传 1 张图片');
			  },
		},
		mounted() {
			this.init()
		}

	}
</script>

<style lang="scss">
	@import "form.scss";
</style>